<template>
  <v-layout row justify-space-between align-center class="px-2 py-3 ranked-providers-list-item">
    <v-flex xs8>
      <v-layout align-center>
        <span class="ranked-providers-list__rank ranked-providers-list-item__col-rank" :class="{'ranked-providers-list-item__col-rank--tie': provider.tie}">{{provider.rank}}</span>
        <a v-if="provider.slug" :href="`/info/${provider.slug}`">
          <span class="ranked-providers-list__logo">
            <!-- Setting img height="100%" to please the beast: IE. Without it IE sets random image sizes... -->
            <img :alt="provider.name" :title="provider.name" v-if="provider.logoUrl" :src="provider.logoUrl" height="100%"/>
            <v-icon :title="provider.name" class="ranked-providers-list-item__logo--generic" medium v-else>store</v-icon>
          </span>
          <!-- TODO: Find out why utility classes like `pl-24` isn't working here -->
          <span class="ranked-providers-list-item__provider-name">
            <span class="font-weight-bold">Pay: </span>{{provider.name}}
          </span>
        </a>
        <span v-else>{{provider.name}}</span>
      </v-layout>
    </v-flex>

    <v-flex xs4>
      <v-layout align-center class="ranked-providers-list-item__col-share" :class="{'col-share_hide': hideUserShare}">
        <div :title="shareTooltipText()" class="ranked-providers-list-item__col-share-wrap">
          <template v-if="provider.share">
            <div class="ranked-providers-list-item__col-share-percent">{{provider.share}}</div>
            <div class="ranked-providers-list-item__col-share-bar" :style="{width: provider.barWidth}"></div>
          </template>
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: {
      provider: {
        type: Object,
        required: true
      },
      hideUserShare: {
        type: Boolean,
        default: true
      },
      geoName: {
        required: true,
        type: Function
      }
    },

    methods: {
      shareTooltipText () {
        return `Share of doxo users in ${this.geoName()} that are customers of ${this.provider.name}`
      }
    }
  }
</script>

<style lang="stylus">
  @require '~styles/bonsai/_settings'

  .ranked-providers-list-item__provider-name {
    padding-left: 24px;
  }

  .ranked-providers-list-item {
    border-bottom: 1px #eee solid

    &__col-share-wrap {
      height: 100%
      position: relative
      display: inline-block

      @media $display-breakpoints.md-and-up {
        width: 45%
      }
      @media $display-breakpoints.sm-and-down {
        margin-right 8px
        width: 100%
      }
    }
    &__col-rank {
      font-size: 17px;
      &--tie {
        color: $grey.base;
      }
    }
    &__logo {
      &--generic {
        color: $blue.darken-2 !important
      }
    }
    &__col-share {
      height 30px
      line-height 30px

      &-percent {
        position: absolute
        right: 5px
        color: #222
        font-size: 15px
        font-weight: bold
      }

      &-bar {
        height: 100%
        background-color: #88bfd6
      }
    }
    &__provider-name {
      display: inline-block
      @media $display-breakpoints.xs-only {
        padding: 0 10px
        display: block
      }
    }
  }
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/ProvidersListItem.vue